import app from 'flarum/forum/app';
import { getClient, setUser, showReportDialog } from '@sentry/browser';
import { createClient, getUserData } from './sentry';
window.Sentry = {
  createClient,
  getClient,
  setUser,
  showReportDialog,
  getUserData
};
app.initializers.add('fof/sentry', () => {
  const config = app.data['fof-sentry'];
  if (!config?.dsn) {
    return;
  }
  const client = createClient(config);
  client.init();

  // Initializers run before the session and forum are loaded. The user needs the session, and
  // lazy chunks need the forum, which supplies their URL.
  app.beforeMount(() => {
    setUser(getUserData());
    if ((config.tracesSampleRate ?? 0) > 0) {
      import(/* webpackChunkName: 'forum/integrations/tracing', webpackMode: 'lazy-once' */ './integrations/tracing').then(_ref => {
        let {
          default: tracing
        } = _ref;
        return client.addIntegration(tracing());
      });
    }
    if ((config.replaysSessionSampleRate ?? 0) > 0 || (config.replaysOnErrorSampleRate ?? 0) > 0) {
      import(/* webpackChunkName: 'forum/integrations/replay', webpackMode: 'lazy-once' */ './integrations/replay').then(_ref2 => {
        let {
          default: replay
        } = _ref2;
        return client.addIntegration(replay());
      });
    }
  });
},
// Ahead of other extensions' initializers, so errors thrown in them are captured.
1000);flarum.reg.addChunkModule('403', '7790', 'fof-sentry', 'forum/integrations/tracing');
flarum.reg.addChunkModule('510', '9386', 'fof-sentry', 'forum/integrations/replay');